var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import ButtonIcon from '../icon/ButtonIcon';
import { mdiChevronDown, mdiChevronRight } from '@mdi/js';
import { COLORS } from '../color';
// Элемент иерархии
var HierarchyItem = /** @class */ (function (_super) {
    __extends(HierarchyItem, _super);
    function HierarchyItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getCollapseButton = function () {
            var _a = _this.props, isCollapseButton = _a.isCollapseButton, collapsed = _a.collapsed, toggleCollapse = _a.toggleCollapse;
            if (isCollapseButton) {
                return (React.createElement(ButtonIcon, { className: 'mr-x2', iconPath: collapsed ? mdiChevronRight : mdiChevronDown, color: COLORS.gray600, size: 'md', title: collapsed ? 'Развернуть' : 'Свернуть', onClick: toggleCollapse }));
            }
            else {
                return null;
            }
        };
        return _this;
    }
    HierarchyItem.prototype.render = function () {
        var _a = this.props, content = _a.content, additionalContent = _a.additionalContent, level = _a.level, collapsed = _a.collapsed, className = _a.className, bordered = _a.bordered, onClick = _a.onClick, classNameItem = _a.classNameItem, classNameAdditionItem = _a.classNameAdditionItem, isPaddingForButton = _a.isPaddingForButton, classNameLevelMap = _a.classNameLevelMap;
        var hilClName = (classNameLevelMap && classNameLevelMap[level]
            ? classNameLevelMap[level]
            : 'hierarchy-item-level-' + level) +
            ' ' +
            (classNameItem ? classNameItem : '');
        var hiClName = 'hierarchy-item ' +
            (isPaddingForButton ? 'py-x3 px-x4 ' : 'p-secondary ') +
            (className ? className : '') +
            (collapsed ? ' hierarchy-item-collapsed' : '') +
            (bordered ? ' hierarchy-item-bordered' : '') +
            (onClick ? ' cursor-pointer' : '');
        return (React.createElement("div", { className: hilClName },
            React.createElement("div", { className: hiClName, onClick: onClick },
                this.getCollapseButton(),
                content),
            collapsed || !additionalContent ? null : (React.createElement("div", { className: 'hierarchy-item-additional' +
                    (bordered ? ' hierarchy-item-bordered' : '') +
                    ' ' +
                    (classNameAdditionItem ? classNameAdditionItem : '') }, additionalContent))));
    };
    return HierarchyItem;
}(Component));
export default HierarchyItem;
//# sourceMappingURL=HierarchyItem.js.map